import React, {useEffect, useState} from 'react';
import ServiceRequestPreRegisterInfo from "./subpage/ServiceRequestPreRegisterInfo";
import {getContentStatus} from "../../../api/contentStatus/contentStatusService";
import {useParams} from "react-router-dom";
import {ContentCategory, ContentStatus} from "../../../constant/CodeSpecNum";
import ServiceRequestInfo from "./subpage/ServiceRequestInfo";
import {useDispatch, useSelector} from "react-redux";
import {changeProgressStatusValue, changeStatusNumericValue} from "../../../redux/slice/contentSlice";
import {DetailHeroSummaryProvider, DetailTabBar} from "../../../components/detailLayout";
import {CommonHistoryList} from "../../settings/history/subPages/CommonHistoryList";

const ServiceRequestView = () => {
    const [tabs, setTabs] = useState([
        {clicked: true, name: "기본정보"},
        {clicked: false, name: "이력상세"},
    ]);
    const [statusNumericValue, setStatusNumericValue] = useState();

    const refreshContent = useSelector(state => state.status.refreshContent);
    const dispatch = useDispatch();
    const {id} = useParams();

    useEffect(() => {
        if (!id) return;
        setStatusNumericValue(undefined);
        handleCallContentStatus();
    }, [id, refreshContent]);

    const handleCallContentStatus = async () => {
        const response = await getContentStatus({contentId: id, contentCategory: ContentCategory.SERVICE_REQUEST});
        if (response && response.status === 200) {
            const numericValue = response.data.statusNumericValue;
            setStatusNumericValue(numericValue);
            dispatch(changeStatusNumericValue(numericValue));
            dispatch(changeProgressStatusValue(response.data));
        }
    }

    return (
        <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray">
            <DetailHeroSummaryProvider>
                <DetailTabBar tabs={tabs} setTabs={setTabs} />
                {statusNumericValue !== undefined && tabs[0].clicked && (
                     statusNumericValue > ContentStatus.PRE_REGISTER.statusNumericValue
                        ? <ServiceRequestInfo key={id} id={id} />
                        : <ServiceRequestPreRegisterInfo key={id} id={id} />
                )}
                {tabs[1].clicked && <CommonHistoryList id={id} tableName={"접수신청/관리"} />}
            </DetailHeroSummaryProvider>
        </div>
    );
};

export default ServiceRequestView;
